//debug log function for offers activation

import {
  addDays,
  FormatDateShortMonth,
  FormatDateYYYYMDD,
  minusDays,
} from './dates'

export const debugLog = (message, data = null, offer) => {
  if (process.env.REACT_APP_ENV === 'dev!!!!!!') {
    console.log(`Current ENV: ${process.env.REACT_APP_ENV}`)
    console.log(`[Offer Debug - ${offer.id}]: ${message}`, data || '')
  }
}

export const checkStartDate = (offer) => {
  const validFrom = new Date(offer.validFromUTC)
  const published = new Date(offer.published)
  // Convert the published date to the given timeZone
  const publishedLocal = new Date(
    published.toLocaleString('en-US', { timeZone: offer.timeZone })
  )
  return publishedLocal < validFrom ? validFrom : publishedLocal
}

export const getValidityDates = ({ offer, tenant, language }) => {
  const checkStartDate = (offer) => {
    const validFrom = new Date(offer.validFromUTC)
    const published = new Date(offer.published)
    const publishedLocal = new Date(
      published.toLocaleString('en-US', { timeZone: offer.timeZone })
    )
    return publishedLocal < validFrom ? validFrom : publishedLocal
  }

  const formatDate = (date, isYYYYMMDD = false) => {
    return isYYYYMMDD ? FormatDateYYYYMDD(date) : FormatDateShortMonth(date)
  }

  const getValidityText = () => {
    const isJapanese = language?.languageid === '529'
    const startDateEnabled =
      tenant?.tenantmasterconfig?.common.start_date_display === 'Y'
    const endDateEnabled =
      tenant?.tenantmasterconfig?.common.end_date_display === 'Y'

    if (!startDateEnabled && !endDateEnabled) return ''

    const parts = []
    if (startDateEnabled) {
      const startDate = formatDate(checkStartDate(offer), isJapanese)
      parts.push(
        isJapanese
          ? `${startDate} ${language?.static_labels.valid_from}`
          : `${language?.static_labels.valid_from} ${startDate}`
      )
    }

    if (endDateEnabled && offer.validTo) {
      const endDate = formatDate(offer.validToUTC, isJapanese)
      if (startDateEnabled) {
        parts.push(
          isJapanese
            ? `${endDate} ${language?.static_labels.valid_to}`
            : `${language?.static_labels.valid_to} ${endDate}`
        )
      } else {
        parts.push(
          isJapanese
            ? `${endDate} ${language?.static_labels.valid_until}`
            : `${language?.static_labels.valid_until} ${endDate}`
        )
      }
    }

    return parts.join(' ')
  }

  return {
    validityText: getValidityText(),
    isEndingSoon: offer.validToUTC && new Date() > minusDays(offer.validToUTC, 14),
    isNew: new Date() < addDays(offer.published, 14),
  }
}
